var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.805 7.7943C11.7404 6.567 10.1737 5.91367 8.14436 5.84967L8.14303 4.195C8.14236 3.82567 7.93369 3.50034 7.59836 3.345C7.26169 3.189 6.87836 3.24167 6.597 3.481L1.99967 7.37697C1.79167 7.5523 1.67033 7.8083 1.66567 8.07897C1.661 8.3483 1.77367 8.60564 1.97367 8.78564L6.579 12.949C6.85769 13.2003 7.24236 13.2623 7.58569 13.111C7.93036 12.9583 8.14436 12.6283 8.14436 12.251V10.1483C10.8804 10.2283 12.633 11.3143 13.6444 13.547C13.6984 13.6676 13.8184 13.743 13.9477 13.743C13.963 13.743 13.979 13.7416 13.9944 13.7396C14.1417 13.7183 14.257 13.603 14.2777 13.457C14.297 13.3176 14.741 10.0263 12.805 7.7943Z",
    fill: "#841474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.cd921f75689a93c85759012d052a6c29.svg";
export { ForwardRef as ReactComponent };